import React, { useEffect, useRef, useState } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ConfirmEmailPage = ({ onConfirmed, onGoToLogin }) => {
  const hasConfirmed = useRef(false);
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Confirming your account...");

  useEffect(() => {
    const confirmEmail = async () => {
      if (hasConfirmed.current) return;
      hasConfirmed.current = true;
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");

      if (!token) {
        setStatus("error");
        setMessage("Confirmation token is missing.");
        return;
      }

      try {
        const res = await fetch(`${API_BASE_URL}/auth/confirm?token=${token}`);
        const data = await res.json();

        if (!res.ok) {
          setStatus("error");
          setMessage(data.detail || "Confirmation failed.");
          return;
        }

        setStatus("success");
        setMessage(data.message || "Account confirmed successfully.");

        // Confirming the link proves ownership of the address, so the API hands back a session
        // and the user continues into the app (or into checkout) without a second login.
        if (data.access_token) {
          onConfirmed?.(data.access_token);
        }
      } catch {
        setStatus("error");
        setMessage("Error calling API.");
      }
    };

    confirmEmail();
  }, [onConfirmed]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#030712",
        fontFamily: "Arial",
        color: "white"
      }}
    >
      <div
        style={{
          width: "420px",
          padding: "36px",
          borderRadius: "18px",
          background: "rgba(15,23,42,0.95)",
          border: "1px solid rgba(255,255,255,0.08)",
          textAlign: "center"
        }}
      >
        <h1>
          {status === "loading" && "Confirming account"}
          {status === "success" && "Account confirmed"}
          {status === "error" && "Confirmation failed"}
        </h1>

        <p
          style={{
            color: status === "success" ? "#86efac" : status === "error" ? "#fca5a5" : "#94a3b8",
            lineHeight: 1.5,
            marginTop: "16px"
          }}
        >
          {message}
        </p>

        {status !== "loading" && (
          <button
            onClick={() => {
              window.history.pushState({}, "", "/");
              onGoToLogin();
            }}
            style={{
              marginTop: "24px",
              width: "100%",
              padding: "14px",
              borderRadius: "12px",
              border: "none",
              cursor: "pointer",
              background: "#4f46e5",
              color: "white",
              fontWeight: 700
            }}
          >
            Go to login
          </button>
        )}
      </div>
    </div>
  );
};

export default ConfirmEmailPage;
